import { Badge, Text } from '@mantine/core';
import { useOs } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import { type CSSProperties, type FC, type MouseEvent } from 'react';
import MantineIcon from '../../../components/common/MantineIcon';
import { PolymorphicGroupButton } from '../../../components/common/PolymorphicGroupButton';
import classes from './OmnibarTarget.module.css';

type Props = {
    placeholder: string;
    style: CSSProperties;
    onOpen: (e: MouseEvent<HTMLInputElement>) => void;
};

const OmnibarTarget: FC<Props> = ({ placeholder, style, onOpen }) => {
    const os = useOs();

    return (
        <PolymorphicGroupButton
            px="sm"
            gap="sm"
            role="search"
            // DL Fork: taller search target; width is owned by the navbar
            // layout (fills the available column) instead of a fixed scale.
            h={42}
            onClick={onOpen}
            style={style}
            wrap="nowrap"
            w="100%"
            className={classes.container}
        >
            <MantineIcon icon={IconSearch} className={classes.icon} />

            <Text c="ldGray.6" size="xs" truncate className={classes.text}>
                {placeholder}
            </Text>

            {/* DL Fork: the keyboard-shortcut badge is hideable via
                VITE_SHOW_OMNIBAR_SHORTCUT=false for embedded deployments. */}
            {import.meta.env.VITE_SHOW_OMNIBAR_SHORTCUT !== 'false' && (
                <Badge
                    fw={500}
                    variant="outline"
                    color="gray"
                    radius="sm"
                    className={classes.badge}
                >
                    {os === 'macos' || os === 'ios' ? '⌘' : 'ctrl'}
                    +K
                </Badge>
            )}
        </PolymorphicGroupButton>
    );
};

export default OmnibarTarget;
